import { useEffect, useState } from 'react';

export default function useHeaderHeight() {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const header = document.querySelector<HTMLElement>('[data-site-header]');

    if (!header) return;

    const observer = new ResizeObserver(() => setHeight(header.offsetHeight));

    observer.observe(header);

    return () => observer.disconnect();
  }, []);

  return height;
}
